import OddsFormatter from "app/components/OddsFormatter/OddsFormatter";
import { OddsType } from "app/utils/const";
import { useEffect, useRef, useState } from "react";
import { FormattedNumber } from "react-intl";
import "./OddsDisplay.scss";

type Props = {
  multiplesOddsType: string;
  decimalOdds: number;
  odds: number;
  legAddedOrRemoved: boolean;
};

function OddsDisplay(props: Props) {
  const { multiplesOddsType, decimalOdds, odds, legAddedOrRemoved } = props;
  const [oddsImproved, setOddsImproved] = useState(false);
  const [oddsShortened, setOddsShortened] = useState(false);
  const prevOdds = useRef(props.odds);

  useEffect(() => {
    // Compare the current odds (props.odds) with the previous odds (prevOdds.current)
    // Only do Odds changed behaviour, ie color change and arrow, when odds change is not caused by a leg being added or removed
    if (props.odds > prevOdds.current && !legAddedOrRemoved) {
      setOddsImproved(true);
      setOddsShortened(false);
      resetOddsChange();
    } else if (props.odds < prevOdds.current && !legAddedOrRemoved) {
      setOddsImproved(false);
      setOddsShortened(true);
      resetOddsChange();
    } else {
      setOddsImproved(false);
      setOddsShortened(false);
    }

    // Update the previous odds reference with the current odds
    prevOdds.current = props.odds;
  }, [props.odds, legAddedOrRemoved]);

  const resetOddsChange = () => {
    setTimeout(() => {
      setOddsImproved(false);
      setOddsShortened(false);
    }, 3000); // Reset after 3 seconds
  };

  const getHighlightClass = () => {
    if (oddsImproved) {
      return "odds-display-odds odds-display-odds--improved";
    } else if (oddsShortened) {
      return "odds-display-odds odds-display-odds--shortened";
    } else {
      return "odds-display-odds";
    }
  };

  return (
    <div className={getHighlightClass()} data-qa={"odds-display"}>
      <div className="odds-display-odds__odds">
        {oddsImproved ? (
          <div className="odds-display-odds__updated odds-display-odds__updated--improved arrow-up" />
        ) : oddsShortened ? (
          <div className="odds-display-odds__updated odds-display-odds__updated--shortened arrow-down" />
        ) : null}
        {/* API formats all odds to 3 decimal places except MALAY */}
        {/* If oddsType is malay then use decimal odds
        if oddsType is other then use user selected odds type */}
        {multiplesOddsType === OddsType.MALAY && (
          <FormattedNumber
            value={decimalOdds}
            minimumFractionDigits={3}
            maximumFractionDigits={3}
          />
        )}
        {multiplesOddsType !== OddsType.MALAY && (
          <span>
            <OddsFormatter odds={odds} oddsType={multiplesOddsType} />
          </span>
        )}
      </div>
    </div>
  );
}

export default OddsDisplay;
